export default "__VITE_ASSET__BDZ0Lva___"